import React, { useEffect, useRef } from 'react';
import styles from './DiscourseMedicalProceduresList.module.scss';
import { useCareClaimsQuery } from '../../../../graphql/graphql';
import DiscourseMedicalProceduresListItem from './DiscourseMedicalProceduresListItem';

interface Props {
	discourseId: string;
	careClaimsListRefreshVersion?: number;
}

const DiscourseMedicalProceduresList = ({
	discourseId,
	careClaimsListRefreshVersion,
}: Props) => {
	const { data, isLoading, refetch } = useCareClaimsQuery({
		where: { documentId: discourseId },
	});

	const prevRefreshVersion = useRef<number | undefined>(undefined);
	const prevDiscourseId = useRef<string | undefined>(undefined);

	useEffect(() => {
		if (typeof careClaimsListRefreshVersion === 'undefined') {
			return;
		}

		if (prevRefreshVersion.current === careClaimsListRefreshVersion) {
			return;
		}

		const shouldRefetch = prevRefreshVersion.current !== undefined;
		prevRefreshVersion.current = careClaimsListRefreshVersion;
		if (shouldRefetch) {
			refetch();
		}
	}, [careClaimsListRefreshVersion, refetch]);

	useEffect(() => {
		if (prevDiscourseId.current === undefined) {
			prevDiscourseId.current = discourseId;
			return;
		}

		if (prevDiscourseId.current !== discourseId) {
			prevDiscourseId.current = discourseId;
			prevRefreshVersion.current =
				typeof careClaimsListRefreshVersion === 'undefined'
					? undefined
					: careClaimsListRefreshVersion;
		}
	}, [discourseId, careClaimsListRefreshVersion]);

	const careClaims = data?.careClaims?.data || [];

	if (isLoading) {
		return <></>;
	}

	return (
		<div className={styles.list}>
			{careClaims.map(careClaim => (
				<DiscourseMedicalProceduresListItem
					key={careClaim.id}
					careClaimId={careClaim.id}
					item={careClaim.medicalProcedure}
					refetch={refetch}
				/>
			))}
		</div>
	);
};

export default DiscourseMedicalProceduresList;
